import React, { useEffect } from 'react';

import { useAuth } from 'hooks/selectors';

const WSChat = () => {
    const { jwt, userCountryName } = useAuth();
    const countryFieldId = '5256111385885';

    useEffect(() => {
        if (__isBrowser__ && typeof zE === 'function' && jwt) {
            zE('messenger', 'loginUser', function (callback) {
                callback(jwt);
            });
            if (userCountryName) {
                zE('messenger:set', 'conversationFields', [{ id: countryFieldId, value: userCountryName }]);
            }
        }
    }, [jwt]);

    return !jwt ? <div id="ze-snippet" /> : null;
};

export default WSChat;
